import React, { useEffect, useState } from "react";

import { useClasseContext } from "../context/ClasseContext";
import { useNavigate } from "react-router-dom";
import {useChefEtablissement} from '../hooks/fetch_api_hook/useChefEtablissement';
import { useUser } from "../context/UserContext";
import { BookOpen, AlertTriangle, Users } from "lucide-react";
import CardClasse from "../components/VueChef/CardClasse";
import FiltreClasse from "../components/VueChef/FiltreClasse";

function RootChef({etablissementId}) {
    const [selectedClasseId, setSelectedClasseId] = useState(null);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [filteredClasses, setFilteredClasses] = useState([]);
    const [viewMode, setViewMode] = useState('grid');

    const { setClasseNom ,classeNom, groupNom, setGroupNom, setClassesGroup, setNomChef} = useClasseContext();
    const [listClasses, setListClasses] = useState([])
    const { etablissementData, refreshEtablissementData } = useUser();

    const navigate = useNavigate();
    const  {data : chefDetail} = useChefEtablissement(etablissementData?.id)
    const computePercentages = (savoirFaires) => {
      const total =
        savoirFaires.nb_vert_plus +
        savoirFaires.nb_vert +
        savoirFaires.nb_vert_pm +
        savoirFaires.nb_yellow +
        savoirFaires.nb_orange +
        savoirFaires.nb_rouge +
        savoirFaires.nb_no_scores;
      return total !== 0 ? 
     {
        nb_vert_plus: total ? savoirFaires.nb_vert_plus / total : 0,
        nb_vert: total ? savoirFaires.nb_vert / total : 0,
        nb_vert_pm: total ? savoirFaires.nb_vert_pm / total : 0,
        nb_yellow: total ? savoirFaires.nb_yellow / total : 0,
        nb_orange: total ? savoirFaires.nb_orange / total : 0,
        nb_rouge: total ? savoirFaires.nb_rouge / total : 0,
        nb_no_scores: total ? savoirFaires.nb_no_scores / total : 0,
      } 
      :
       0
    };
   // Refresh des données au montage du composant
   useEffect(() => {
      refreshEtablissementData();
   }, []); // eslint-disable-line react-hooks/exhaustive-deps

   useEffect( ()=>
    {
        if(chefDetail.length > 0 && etablissementData) {

            setClasseNom('')
            setNomChef(chefDetail[0].nom + ' ' + chefDetail[0].prenom)
            setListClasses(etablissementData.classes)
        }
    }
,[chefDetail, setClasseNom, setNomChef, etablissementData])

const handleRowClick = (item,type) => {

    if(!type){
   
      setSelectedClasseId(item.id);
      localStorage.setItem('groupeActive', '')
      localStorage.setItem('classeActive', item.nom)
      setGroupNom('')
      setClasseNom(item.nom)
    
      }
      else{
        setSelectedGroupId(item.id)
        localStorage.setItem('classeActive', '')
        localStorage.setItem('groupeActive',item.nom)
        setClassesGroup(item.classes_detail)
        setClasseNom('')
        setGroupNom(item.nom)
      }
    
  }

  useEffect(()=> {
    if(selectedClasseId){
      navigate(`/home/detail/${selectedClasseId}`)
    }

  },[selectedClasseId,navigate])

return(
<>
  <div className="">
    {/* Header - Glass style */}
    <div className="px-4 sm:px-6 lg:px-8 xl:px-5 2xl:px-6 3xl:px-8 py-4 sm:py-6 xl:py-3 2xl:py-4 3xl:py-6">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 xl:gap-4 2xl:gap-5 3xl:gap-6">
        <div>
          <div className="flex items-center gap-4 xl:gap-3 2xl:gap-3.5 3xl:gap-4 mb-3 xl:mb-2 2xl:mb-2.5 3xl:mb-3">
            <div className="p-4 xl:p-2.5 2xl:p-3 3xl:p-4 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-2xl shadow-2xl shadow-blue-500/50">
              <BookOpen className="text-white xl:w-5 xl:h-5 2xl:w-6 2xl:h-6 3xl:w-8 3xl:h-8" size={32} />
            </div>
            <div>
              <h1 className="text-4xl xl:text-2xl 2xl:text-3xl 3xl:text-4xl font-black bg-gradient-to-r from-slate-800 to-blue-700 bg-clip-text text-transparent">
                Classes de l'établissement
              </h1>
              <p className="text-slate-600/80 text-xl xl:text-sm 2xl:text-base 3xl:text-xl mt-1 font-medium">
                Cliquez sur une classe pour consulter ses performances, évaluations et autres informations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Alert for empty classes */}
    {listClasses && listClasses.some(c => c.nombre_eleves === 0) && (
      <div className="mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6 px-4 sm:px-6 lg:px-8 xl:px-5 2xl:px-6 3xl:px-8">
        <div className="p-2 xl:p-1.5 2xl:p-2 3xl:p-2 bg-gradient-to-r from-amber-50 to-orange-50 border
         border-amber-200/50 rounded-2xl flex flex-col sm:flex-row items-start sm:items-center
          justify-between gap-4 xl:gap-3 2xl:gap-3.5 3xl:gap-4 shadow-sm">
          <div className="flex items-center gap-4 xl:gap-3 2xl:gap-3.5 3xl:gap-4">
            <div className="p-3 xl:p-2 2xl:p-2.5 3xl:p-3 bg-amber-100 rounded-xl">
              <AlertTriangle size={22} className="text-amber-600 xl:w-4 xl:h-4 2xl:w-5 2xl:h-5 3xl:w-[22px] 3xl:h-[22px]" />
            </div>
            <div>
              <p className="font-semibold text-xl xl:text-sm 2xl:text-base 3xl:text-xl text-amber-800">
                {listClasses.filter(c => c.nombre_eleves === 0).length} classe(s) sans élèves
              </p>
              <p className="text-sm xl:text-xs 2xl:text-xs 3xl:text-sm text-amber-600">Importez vos élèves pour commencer les évaluations</p>
            </div>
          </div>
        </div>
      </div>
    )}

    {/* Bouton import toujours visible */}
    {listClasses && listClasses.length > 0 && (
      <div className="mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4 px-4 sm:px-6 lg:px-8 xl:px-5 2xl:px-6 3xl:px-8 flex justify-end">
        <button
          className="px-5 xl:px-3 2xl:px-4 3xl:px-5 py-2.5 xl:py-1.5 2xl:py-2 3xl:py-2.5 bg-gradient-to-r from-blue-500 to-sky-500
           text-white font-medium text-xl xl:text-xs 2xl:text-sm 3xl:text-xl rounded-xl shadow-lg shadow-blue-500/25 hover:shadow-xl
            hover:shadow-blue-500/30 transition-all flex items-center gap-2 xl:gap-1.5 2xl:gap-2 3xl:gap-2"
          onClick={() => navigate('/home/import-etablissement')}
        >
          <Users size={18} className="xl:w-3.5 xl:h-3.5 2xl:w-4 2xl:h-4 3xl:w-[18px] 3xl:h-[18px]" />
          Importer des élèves
        </button>
      </div>
    )}

    {/* Filtres */}
    <div className="px-4 sm:px-6 lg:px-8 xl:px-5 2xl:px-6 3xl:px-8">
      <FiltreClasse
        classes={listClasses}
        onFilterChange={setFilteredClasses}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
      />
    </div>

    {/* Version Desktop : Cards modernes (lg et plus) */}
    <div className="hidden lg:block p-6">
      <div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-6">
        {filteredClasses && filteredClasses.map((classItem, index) => {
          const percentages = computePercentages(classItem.savoir_faires);
          return (
            <CardClasse
              key={index}
              classItem={classItem}
              percentages={percentages}
              onRowClick={handleRowClick}
              index={index}
            />
          );
        })}
      </div>
    </div>

    {/* Version Tablette : Cards (md) */}
    <div className="hidden md:block lg:hidden p-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {filteredClasses && filteredClasses.map((classItem, index) => {
          const percentages = computePercentages(classItem.savoir_faires);
          return (
            <CardClasse
              key={index}
              classItem={classItem}
              percentages={percentages}
              onRowClick={handleRowClick}
              index={index}
            />
          );
        })}
      </div>
    </div>

    {/* Version Mobile : Cards (sm et moins) */}
    <div className="block md:hidden p-4">
      <div className="grid grid-cols-1 gap-4">
        {filteredClasses && filteredClasses.map((classItem, index) => {
          const percentages = computePercentages(classItem.savoir_faires);
          return (
            <CardClasse
              key={index}
              classItem={classItem}
              percentages={percentages}
              onRowClick={handleRowClick}
              index={index}
            />
          );
        })}
      </div>
    </div>
  </div>
</>
)
}

export default RootChef;